import { createSlice } from "@reduxjs/toolkit";

const reportingSlice = createSlice({
  name: "reporting",
  initialState: {
    reportingData: [],
    isSaved: false,
    LookupTable:[],
    activeTabKey: null,
    ReportForm: {},
    emissionSaved: {},
    SwitchState: {}, 
    isLoading: true,
    isReset:false,
    isCalculated:false,
    isQuestionCalculated:{},
  },
  reducers: {
    setIsQuestionCalculated(state,action){
      const {pillarId,questionId,value}=action.payload;

      if(!state.isQuestionCalculated[[pillarId]]){
        state.isQuestionCalculated[pillarId]={}
      }
     
      state.isQuestionCalculated[pillarId][questionId]=value;
    },
    resetIsQuestionCalculated(state,action){
      const {pillarId,questionId}=action.payload;
      if (state.isQuestionCalculated[pillarId]) {
        if (questionId) {
          delete state.isQuestionCalculated[pillarId][questionId];
        } else {
          state.isQuestionCalculated[pillarId] = {};
        }
      }
    },

    setactiveTabKey(state, action) {
      state.activeTabKey = action.payload;
    },
    setreportingData(state, action) {
      state.reportingData = action.payload;
      /*const energyTab = action.payload.find((data) => data.pillarId === "Energy");
      state.activeTabKey = energyTab ? energyTab.pillarId : action.payload[0].pillarId;*/
      state.isLoading = false;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setisReset(state, action) {
      state.isReset = action.payload;
    },
    setLookupTable(state,action)
    {
        state.LookupTable=action.payload;
    },
    setisSaved(state, action) {
      state.isSaved = action.payload;
    },
    setisCalculated(state,action){
      state.isCalculated=action.payload
    },
    setReportForm: (state, action) => {
      const { pillarId, questionId, inputId, rowId, value } = action.payload;

      state.ReportForm[pillarId] = state.ReportForm[pillarId] || {};
      state.ReportForm[pillarId][questionId] = state.ReportForm[pillarId][questionId] || { inputFields: {} };

      // Handle row deletion when value is null and rowId is provided
      if (value === null && rowId) {
        const currentFields = state.ReportForm[pillarId][questionId].inputFields;
        const updatedFields = {};
        
        // Remove the specified row and reorder remaining rows
        Object.entries(currentFields)
          .filter(([currentRowId]) => currentRowId !== rowId)
          .forEach(([currentRowId, fieldValues], index) => {
            const newRowId = `row${(index + 1).toString().padStart(3, '0')}`;
            updatedFields[newRowId] = fieldValues;
          });
        
        // Update the input fields with reordered data
        state.ReportForm[pillarId][questionId].inputFields = updatedFields;

        // Clean up empty structures
        if (Object.keys(updatedFields).length === 0) {
          delete state.ReportForm[pillarId][questionId];
          if (Object.keys(state.ReportForm[pillarId]).length === 0) {
            delete state.ReportForm[pillarId][questionId];
          }
        }
        return;
      }

      // Handle normal field updates
      if (rowId) {
        state.ReportForm[pillarId][questionId].inputFields[rowId] = 
          state.ReportForm[pillarId][questionId].inputFields[rowId] || {};
        state.ReportForm[pillarId][questionId].inputFields[rowId][inputId] = value;
      } else {
        state.ReportForm[pillarId][questionId].inputFields[inputId] = value;
      }
    },
      resetReportForm(state, action) {
        const { pillarId, questionId } = action.payload;
        if (state.ReportForm[pillarId]) {
          if (questionId) {
            delete state.ReportForm[pillarId][questionId];
          } else {
            state.ReportForm[pillarId] = {};
          }
        }
      },
    setSwitchState: (state, action) => {
      const { pillarId, questionId, value } = action.payload;
      if (!state.SwitchState[pillarId]) {
        state.SwitchState[pillarId] = {};
      }
      if (!state.SwitchState[pillarId][questionId]) {
        state.SwitchState[pillarId][questionId] = {};
      }
      state.SwitchState[pillarId][questionId] = value;
    },
    resetSwitchState(state, action) {
      const { pillarId } = action.payload;
      if (state.SwitchState[pillarId]) {
        state.SwitchState[pillarId] = {};
      }
    },
    setEmissionSaved: (state, action) => {
        const { pillarId, questionId, value } = action.payload;
      
        if (!state.emissionSaved[pillarId]) {
          state.emissionSaved[pillarId] = {};
        }
      
        state.emissionSaved[pillarId][questionId] = value;
      },
      resetEmissionSaved(state, action) {
        const { pillarId, questionId } = action.payload;
        if (state.emissionSaved[pillarId]) {
          if (questionId) {
            delete state.emissionSaved[pillarId][questionId];
          } else {
            state.emissionSaved[pillarId] = {};
          }
        }
      },
      populateReportForm: (state, action) => {
        const SavedData = action.payload;
  
     // Handle both possible data structures: from CDP and the new pillars
        SavedData.forEach((pillar) => {
        // Initialize state for this pillar
        state.ReportForm[pillar.pillarId] = state.ReportForm[pillar.pillarId] || {}
        state.emissionSaved[pillar.pillarId] = state.emissionSaved[pillar.pillarId] || {}
        state.SwitchState[pillar.pillarId] = state.SwitchState[pillar.pillarId] || {}
        state.isQuestionCalculated[pillar.pillarId] = state.isQuestionCalculated[pillar.pillarId] || {}

        // Check if we have the reportQuestionAnwsers format (CDP) or actualResponses format (other pillars)
        if (pillar.reportQuestionAnwsers && Array.isArray(pillar.reportQuestionAnwsers)) {
          // CDP-style data structure
          pillar.reportQuestionAnwsers.forEach((question) => {
            const questionId = question.questionId

            // Mark question as selected
            state.SwitchState[pillar.pillarId][questionId] = true

            // Mark question as calculated
            state.isQuestionCalculated[pillar.pillarId][questionId] = true

            // Initialize question structure
            state.ReportForm[pillar.pillarId][questionId] = state.ReportForm[pillar.pillarId][questionId] || {
              inputFields: {},
            }

            // Process each response
            if (question.response && Array.isArray(question.response)) {
            question.response.forEach((response) => {
                if (response.emissionSaved !== undefined) {
                  state.emissionSaved[pillar.pillarId][questionId] = response.emissionSaved
                }

                // Handle table data vs regular form data
                if (response.responseId && response.responseId.startsWith("row")) {
                  // Table data
                  if (response.answers && Array.isArray(response.answers)) {
              response.answers.forEach((answer) => {
                      if (!state.ReportForm[pillar.pillarId][questionId].inputFields[response.responseId]) {
                        state.ReportForm[pillar.pillarId][questionId].inputFields[response.responseId] = {}
                      }
                      state.ReportForm[pillar.pillarId][questionId].inputFields[response.responseId][answer.fieldId] =
                        answer.value
                    })
                  }
                } else {
                  // Regular form fields
                  if (response.answers && Array.isArray(response.answers)) {
                    response.answers.forEach((answer) => {
                      state.ReportForm[pillar.pillarId][questionId].inputFields[answer.fieldId] = answer.value
                    })
                  }
                }
              })
            }
          })
        } else if (pillar.actualResponses && Array.isArray(pillar.actualResponses)) {
          // New pillars (Energy, Waste, Packaging) structure
          pillar.actualResponses.forEach((question) => {
            const questionId = question.questionId

            // Mark question as selected
            state.SwitchState[pillar.pillarId][questionId] =
              question.isSelected === undefined ? true : question.isSelected

            // Mark question as calculated
            state.isQuestionCalculated[pillar.pillarId][questionId] = true

            // Set emission saved value
            if (question.totalEmissionSaved !== undefined) {
              state.emissionSaved[pillar.pillarId][questionId] = question.totalEmissionSaved
            }

            // Initialize question structure
            state.ReportForm[pillar.pillarId][questionId] = state.ReportForm[pillar.pillarId][questionId] || {
              inputFields: {},
            }

            // Process responses
            if (question.responses && Array.isArray(question.responses)) {
              question.responses.forEach((response) => {
                if (response.responseId && response.responseId.startsWith("row")) {
                  // Table data
                state.ReportForm[pillar.pillarId][questionId].inputFields[response.responseId] =
                   state.ReportForm[pillar.pillarId][questionId].inputFields[response.responseId] || {}

                  if (response.response && Array.isArray(response.response)) {
                    response.response.forEach((field) => {
                    state.ReportForm[pillar.pillarId][questionId].inputFields[response.responseId][field.fieldId] =
                     field.value
              });
                }
                } else {
                  // Regular fields
                  if (response.response && Array.isArray(response.response)) {
                    response.response.forEach((field) => {
                      state.ReportForm[pillar.pillarId][questionId].inputFields[field.fieldId] = field.value
                    });
                  }
                }
          });
            }
          });
        }
        });
      },
    },
});

export const { setreportingData, setactiveTabKey, setisSaved,setLoading, setReportForm,setLookupTable,setEmissionSaved, setSwitchState,resetSwitchState,setisReset, resetReportForm,resetEmissionSaved,populateReportForm,setisCalculated,setIsQuestionCalculated,resetIsQuestionCalculated, } = reportingSlice.actions;
export default reportingSlice.reducer;
